import {lazy} from '@aboutyou/lazy-imports';

export const Brands = lazy(() =>
  import('./Brands.eager').then(mod => ({
    default: mod.Brands,
  })),
);
